import { Component, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { AppUser } from '@shared/models/app-user.model'
import { AttendeesService } from '@shared/services/attendees.service'
import { UserService } from '@shared/services/user.service'
import { callableErrorMessage } from '@shared/errors/callable-error-message'
import { AdminToastService } from '../../services/notification/admin-toast.service'

@Component({
  selector: 'app-user-delete-confirmation',
  templateUrl: './user-delete-confirmation.component.html',
  styleUrls: ['./user-delete-confirmation.component.css'],
  standalone: false,
})
export class UserDeleteConfirmationComponent {
  user: AppUser
  isDeleting = false
  errorMessage = ''
  private readonly messages = {
    success: 'A felhasználó törölve.',
    error: 'A törlés nem fejeződött be.',
  }

  constructor(
    private userService: UserService,
    private attendeesService: AttendeesService,
    private toastService: AdminToastService,
    private dialogRef: MatDialogRef<UserDeleteConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    if (data && data.user) {
      this.user = data.user
    }
  }

  confirm(): void {
    if (this.isDeleting) {
      return
    }
    this.isDeleting = true
    this.errorMessage = ''
    this.userService.deleteUser(this.user.id).subscribe({
      next: () => {
        this.isDeleting = false
        this.attendeesService.clearCache()
        this.toastService.showSuccess(this.messages.success)
        this.dialogRef.close(true)
      },
      error: error => {
        console.error('Error deleting user:', error)
        this.isDeleting = false
        this.errorMessage = callableErrorMessage(error, this.messages.error)
      },
    })
  }

  close() {
    if (this.isDeleting) {
      return
    }
    this.dialogRef.close()
  }
}
